import { inject, singleton } from "tsyringe";
import {
  ConsentProviderInterface,
  ConsentResolvedCallback,
} from "@identity/services";
import { SimpleTcfApi } from "../consentProviders/simple-tcf-api";

@singleton()
export class StaticConsentStrategy implements ConsentProviderInterface {
  constructor(@inject(SimpleTcfApi) private readonly tcfApi: SimpleTcfApi) {
    this.tcfApi.install();
  }

  subscribe(callback: ConsentResolvedCallback): void {
    callback({
      gdprConsent: true,
      geoRequiresSignal: false,
      geoRequiresConsent: false,
      ccpaSignal: false,
    });
  }
}
